import 'date-fns';
import Grid from '@material-ui/core/Grid';
import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers';
import { createTheme } from '@material-ui/core';
import { ThemeProvider } from '@material-ui/styles';
import InputAdornment from '@material-ui/core/InputAdornment';
import Event from '@material-ui/icons/Event';
import styles from './Datepicker.module.scss';
import { maxDatePickerRange } from '../commons/utils/utils';

export default function DatepickerComponent(
  _date,
  fn,
  props,
  setNextOrderDate = () => {},
  ...rest
) {
  const handleDateChange = (date) => {
    fn(date);
    setNextOrderDate(date);
  };

  const zIndex = {
    mobileStepper: 1000,
    fab: 1050,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 100000,
    snackbar: 1400,
    tooltip: 1500,
  };

  const materialTheme = createTheme({
    palette: {
      primary: {
        main: '#004152',
      },
    },
    typography: {
      fontFamily: ['Whitney Semibold'].join(','),
    },
    zIndex: {
      ...zIndex,
    },
  });
  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <Grid container className={styles.datepickerGrid}>
        <ThemeProvider theme={materialTheme}>
          <DatePicker
            disableToolbar
            variant="dialog"
            format="MM/dd/yyyy"
            id="date-picker-inline"
            placeholder="Select Date"
            // views={['date', 'month', 'year']}
            minDate={new Date()}
            maxDate={maxDatePickerRange()}
            value={_date}
            onChange={handleDateChange}
            {...rest}
            InputProps={{
              endAdornment: (
                <InputAdornment
                  className={styles.datepickerIcon}
                  position="end"
                >
                  <Event fontSize="large" />
                </InputAdornment>
              ),
            }}
            {...props}
          />
        </ThemeProvider>
      </Grid>
    </MuiPickersUtilsProvider>
  );
}
